import ReactMarkdown from 'react-markdown';
import type { ChatTurn } from './types';
import { SourceRows } from './SourceRows';

/**
 * One thread turn. User turns render as plain text; assistant turns render the
 * answer as markdown, with an optional "tools used" note and a generic
 * source-rows table built from `data`. Domain-free.
 */
export function MessageBubble({
  turn,
  toolsUsed,
  data,
}: {
  turn: ChatTurn;
  toolsUsed?: string[];
  data?: unknown;
}) {
  const isUser = turn.role === 'user';
  return (
    <div className={`ra-bubble flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[85%] rounded-lg px-3 py-2 text-sm ${
          isUser ? 'bg-blue-600 text-white' : 'bg-neutral-100 text-neutral-900'
        }`}
      >
        {isUser ? (
          <span className="whitespace-pre-wrap">{turn.content}</span>
        ) : (
          <div className="ra-prose prose prose-sm max-w-none">
            <ReactMarkdown>{turn.content}</ReactMarkdown>
          </div>
        )}
        {!isUser && toolsUsed && toolsUsed.length > 0 && (
          <div className="mt-1 text-[11px] text-neutral-500">Sources: {toolsUsed.join(', ')}</div>
        )}
        {!isUser && <SourceRows data={data} />}
      </div>
    </div>
  );
}
